import Switch from '@shared/Form/Switch'
import { Field } from 'components/Form'
import { pathOr } from 'ramda'
import React from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  name: string
  item?: any
}
const ActivateFormField = React.memo(({ item, name, ...props }: Props) => {
  const { t } = useTranslation()

  const activeValue = pathOr(1, [name], item)
  const [isActive, setIsActive] = React.useState(
    activeValue === 1 || activeValue === true
  )

  return (
    <>
      <div className="text-larger mr-8">
        {isActive ? t(`device:active`) : t(`device:inactive`)}
      </div>
      <Field
        {...props}
        name={name}
        getValueFromEvent={val => {
          setIsActive(val)
          return val
        }}
        valuePropName="checked"
        className="w-60"
        initialValue={isActive}>
        <Switch />
      </Field>
    </>
  )
})

export default ActivateFormField
